import { Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap';

import DOMPurify from 'dompurify';
import React from 'react';

function InfoTab({ career }) {
  if (!career) return <React.Fragment />;
  return (
    <Row>
      <Col sm="12">
        <Card className="card-chart">
          <CardHeader>
            <CardTitle className="mt-0">Details</CardTitle>
          </CardHeader>
          <CardBody>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Title</span>
              </div>
              <div> {career.title} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Team</span>
              </div>
              <div> {career.team.toUpperCase()} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Status</span>
              </div>
              <div>{career.status.toUpperCase()}</div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col sm="12">
        <Card className="card-chart">
          <CardHeader>
            <CardTitle className="mt-0">Excerpt</CardTitle>
          </CardHeader>
          <CardBody>{career.excerpt || 'No excerpt provided.'}</CardBody>
        </Card>
      </Col>

      <Col sm="12">
        <Card className="card-chart">
          <CardHeader>
            <CardTitle className="mt-0">Description</CardTitle>
          </CardHeader>
          <CardBody>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  career.description || 'No description provided.'
                ),
              }}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default React.memo(InfoTab);
